module.exports = __webpack_public_path__ + "img/about-12.b1f88e39.png";